<template>
  <v-app :key="refresh">
    <div class="">
<!--      <v-btn class="p-0 english" @click="setEnglishLanguage">
        <img src="../src/assets/img/Flag_of_the_United_States.png" class="">
      </v-btn>
      <v-btn class="p-0 farsi" @click="setFarsiLanguage">
     <img src="../src/assets/img/Flag_of_Iran.png" class="">
      </v-btn>-->

      <vue-page-transition>
        <router-view>

        </router-view>
      </vue-page-transition>
    </div>

<!--    <v-fab-transition>
      <a href=" https://wa.me/+989126770412" target="_blank" id="whatsAppFab">
        <v-btn
            class="black&#45;&#45;text mb-3 ml-3"
            x-large
            color="green"
            elevation="0"
            fab
            fixed
            bottom
            left
        >
          <i class="fab fa-whatsapp contactUs-fab mb-1 ml-1"></i>
        </v-btn>
      </a>
    </v-fab-transition>-->
  </v-app>

</template>

<script>

export default {
  name: "App",
  components: {},
  data: () => ({
    //
    refresh: 1
  }),

  methods: {
    setAutumn(){
      this.$setUserSeason("Autumn")

      window.location.reload();
    },

    setWinter(){
      this.$setUserSeason("Winter")

      window.location.reload();
    },

    setSpring(){
      this.$setUserSeason("Spring")

      window.location.reload();
    },

    setSummer(){
      this.$setUserSeason("Summer")

      window.location.reload();
    },

  },
  mounted() {
       this.$changeRTL();
  }
};
</script>
